import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'av-picture',
  templateUrl: './av-picture.component.html',
  styleUrls: ['./av-picture.component.scss']
})
export class AvPictureComponent implements OnInit {
  @Input() imgSrc: string = '';
  @Output() onChange = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onExternalEdit = new EventEmitter<any>();

  constructor() { }

  endpointParam: string = '';

  isUpdatingImage = false;
  isSavingNewImage = false;
  imageHasLoaded = false;
  iconInsteadOfImage = 'fal fa-image fa-2x';
  
  imagePreview() {
  }
  
  showImageLoading() {
    this.iconInsteadOfImage = 'fal fa-spinner fa-spin fa-2x';
  }

  showImageError() {
    //If there is image source, show that we couldn't get the image
    if (this.imgSrc) {
      this.iconInsteadOfImage = 'fal fa-file-times fa-2x';
    } else {
      this.iconInsteadOfImage = 'fal fa-image fa-2x';
    }
  }

  showImageLoaded() {
    this.imageHasLoaded = true;
  }
  
  // To update image we can either use built in file uploader
  // or call the external edit function callback
  toggleUpdateImage() {
    if (true) {
      this.onExternalEdit.emit();
    } else {
      this.isUpdatingImage = !this.isUpdatingImage;
    }
  }

  uploadStarted() {
      this.isSavingNewImage = true;
  }
  
  onUploaded(isSuccess) {
    this.isSavingNewImage = false;
    
    if (isSuccess) {
      this.toggleUpdateImage();
    }

    // Let parent know that change happened
    this.onChange.emit({$event: isSuccess});
  }
  
  onDeleteClick() {
    this.onDelete.emit({ $event: this.endpointParam });
  }

  ngOnInit(): void {
  }

}
